import { getBlurAnimation } from '../animations/blur'

export function getTextBlurAnimation (element, settings) {
    return {
        from: getBlurAnimation(element, { ...settings, blur: settings.blur ?? 0.5 }),
    }
}
